import { useEffect, useRef } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import systemSlice from "../../../redux/systemSlice"

const RenderIframe = () => {
    const iframeContainerRef = useRef()

    const dispatch = useDispatch()
    const iframeProps = useSelector(state => state.systemSlice.iframeProps)
    function renderWithIframe(htmlContent) {
        const iframe = document.createElement('iframe');
        iframe.style.border = 'none';
        iframe.style.width = "450px"
        iframe.style.height = "500px"

        iframeContainerRef?.current?.appendChild(iframe)
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(htmlContent);
        doc.close();

    }
    useEffect(() => {

        if (iframeProps.htmlContent)
            renderWithIframe(iframeProps.htmlContent)
    }, [iframeProps])
    return (
        <>
            {iframeProps?.htmlContent &&

                <div className="fixed top-0 left-0 bg-gray-400 bg-opacity-40 flex flex-col items-center justify-center w-full h-full">
                    <div ref={iframeContainerRef} className="bg-white flex flex-col p-4">
                        <div className="w-full">

                            <div className="ml-auto bg-white border-1 border-gray-700 w-[40px] h-[40px] rounded-full flex items-center justify-center cursor-pointer"
                                onClick={() => {
                                    dispatch(systemSlice.actions.setIframeProps({}))
                                }}>X</div>
                        </div>

                    </div>

                </div>}
        </>
    )
}

export default RenderIframe